import React from "react";

import { Text } from "./styles";

interface Props {
  text: string;
  color: string;
  fontSize: number;
  variant:
    | "body1"
    | "body2"
    | "button"
    | "caption"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "inherit"
    | "overline"
    | "subtitle1"
    | "subtitle2";
}

const Typography: React.FC<Props> = ({ text, variant, color, fontSize }) => {
  return (
    <Text style={{ color, fontSize, lineBreak: "anywhere" }} variant={variant}>
      {text}
    </Text>
  );
};
export default Typography;
